import {
  RESET_STORE,
  IS_CONTENT_LOADING,
  IS_LABEL_LOADING,
  IS_ISSUE_TYPE_LOADING,
  SET_DATASET_SORTING_VALUE,
  SET_FILTER_ISSUE,
  SET_ISSUE_DATA,
  SET_SEVERITY_DATA,
  IS_CARDSLIST_LOADING,
  SET_SIMILARITY_DATA,
  SET_SIMILARITY_VERTEX,
  SET_SIMILARITY_THRESHOLDS,
  SET_ENTITY_TYPE_FILTER,
  SET_DATASET_LABELS,
  SET_DATASET_ISSUE_TYPES,
  SET_EXPLORATION_STATS,
  SET_NAVIGATION_CLUSTER,
  SET_NAVIGATION_CLUSTER_LOADER,
  SET_FILE_NAME_SEARCH_TEXT,
  SET_FILTER_CONFIG,
  SET_TREE_FOLDER,
  SET_EXPORT_DATA,
  SET_SHOW_CART,
  SET_TEMP_EXPORT_DATA,
  SET_TEMPORARY_EXPORT_DATA,
  SET_EXPORT_DATA_TIMEOUT_ID,
  SET_PAGINATION_METADATA_FOR_DATA,
  SET_PAGINATION_METADATA_FOR_CLUSTER,
  SET_CLUSTER_METADATA_SUMMARY,
  SET_CLUSTER_METADATA_SUMMARY_LOADING,
  SET_USER_TAGS,
  UPDATE_USER_TAGS,
  IS_USER_TAG_LOADING,
  SET_NAVIGATION_CONTEXT,
  SET_IS_IMAGE_UPLOADING,
  HOVERED_FILE_STATE,
  SET_FETCH_ERROR,
  SET_DATA_METADATA_SUMMARY,
  SET_DATA_METADATA_SUMMARY_LOADING,
  SET_AUTOCOMPLETE_SUGGESTIONS,
  SET_RECENT_SEARCHES,
  SET_AUTOCOMPLETE_LOADING,
  SET_AUTOCOMPLETE_NO_RESULTS_FLAG,
  SET_IMAGE_PAGE_PARAMS_CONTEXT,
  SET_ASSIGNED_TAGS,
  SET_SHOW_EXPORT_MODAL,
  SET_EXPORT_PROGRESS,
  SET_EXPORT_STATUS,
  SET_SHOW_DATASET_SHARING_MENU,
  SET_USERS_WITH_ACCESS,
  SET_INVITED_EMAILS,
  SET_DATASET_TAGS,
  IS_FILE_FILTER_LOADING,
  SET_IS_USER_CONFIG_LOADING,
  SET_LAST_SELECTED_INDEX,
  SET_SCROLL_APPLIED,
  SET_DATA_PAGE_SCROLL_POSITION,
  SET_CLUSTER_PAGE_SCROLL_POSITION,
  SET_NO_RESULTS_FOUND,
  SET_DATASET_ENRICHMENT_MODELS,
  SET_CAPTIONS,
  SET_NAVIGATION_CLUSTER_TAGS,
  SET_DUPLICATE_THRESHOLD_RANGE,
  SET_DATASET_EXTERNAL_SOURCES,
  SET_SHOW_VIEW_SHARING_MENU,
  SET_REMOVED_ELEMENTS_BY_UNIQUENESS_COUNT,
  SET_IS_UNIQUENESS_SCORE_LOADING,
  SET_SELECTED_QUERY_MODAL,
  SET_SHOW_QUERY_PANEL,
  SET_DATASET_CONTEXTUAL_LABELS,
  SET_CONTEXTUAL_USER_TAGS,
  SET_TEMPORARY_ASSIGNED_TAGS,
  SET_CUSTOM_METADATA_LINK_OPTIONS,
  SET_GLOBAL_MD_TYPE,
  SET_METADATA_SOURCES_LOADING,
} from "./constants";
import { ExportData, MetadataItem, MetadataType } from "types";
import { SingleDatasetState } from "./types";

export const initialEntityTypeFilter: MetadataItem[] = [
  { id: 0, text: "IMAGES" },
];

const initialImagePageParamsContext = {
  imageId: "",
  searchRegion: "",
};

const initialViewSharingMenu = {
  showSharingMenu: false,
  associatedViewId: null as string | null,
};

const initialExportData: ExportData | null =
  JSON.parse(localStorage.getItem("cart__data") as string) || null;

const initialRecentSearches =
  JSON.parse(localStorage.getItem("recent_searches") as string) || {};

export const INITIAL_STATE: SingleDatasetState = {
  datasetSortingValue: "Severity",
  isContentLoading: false,
  isLoading: false,
  issues: null,
  stats: null,
  similarityVertexCluster: null,
  similarityClusters: [],
  isCardslistLoading: true,
  isLabelLoading: false,
  isIssueTypeLoading: false,
  isFileFilterLoading: false,
  isUserConfigLoading: false,
  explorationStats: null,
  navigationCluster: null,
  navigationClusterLoader: false,
  navigationClusterTags: null,
  filterConfig: [],
  treeFolder: null,
  exportData: initialExportData,
  temporaryExportData: null,
  showCart: false,
  tempExportData: null,
  exportDataTimeoutID: null,
  paginationMetadataForData: null,
  paginationMetadataForCluster: null,
  clusterMetadataSummaryLoading: true,
  clusterMetadataSummary: null,
  metadataSourcesLoading: true,
  datasetTags: [],

  // filters
  labels: [],
  contextualLabels: [],
  issueTypes: [],
  fileNameSearchText: "",
  entityTypeFilter: initialEntityTypeFilter,
  filterFolder: null,
  userTags: [],
  contextualUserTags: [],
  captions: [],
  //----------------------------
  navigationContext: [],
  isImageUploading: false,
  hoveredFileState: null,
  fetchError: false,
  dataMetadataSummaryLoading: true,
  dataMetadataSummary: null,
  autocompleteSuggestions: [],
  recentSearches: initialRecentSearches,
  autocompleteLoading: false,
  autocompleteNoResultsFlag: false,
  imagePageParamsContext: initialImagePageParamsContext,
  assignedTags: [],
  temporaryAssignedTags: [],
  showExportModal: null,
  exportProgress: 0,
  exportStatus: null,
  exportFileLink: null,
  showDatasetSharingMenu: false,
  viewSharingMenu: initialViewSharingMenu,
  usersWithAccess: [],
  invitedEmails: [],
  lastSelectedIndex: null,
  scrollApplied: false,
  dataPageScrollPosition: null,
  clusterPageScrollPosition: null,
  noResultsFound: false,
  externalSources: [],
  enrichmentModels: [],
  savedViews: [],
  savedViewsLoading: true,
  duplicateThresholdRange: null,
  removedElementsByUniquenessCount: null,
  uniquenessScoreLoading: false,
  similarityThresholds: [],

  //Query Filter States
  selectedQueryModal: null,
  showQueryPanel: false,
  customMetadataLinkOptions: [],
  globalMDType: MetadataType.IMAGE_LABELS,
};

const reducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case RESET_STORE:
      const filterConfig = state.filterConfig;
      const exportData = state.exportData;
      const stats = state.stats;
      const similarityThresholds = state.similarityThresholds;
      return {
        ...state,
        ...INITIAL_STATE,
        filterConfig,
        exportData,
        stats,
        similarityThresholds,
      };

    case IS_CONTENT_LOADING:
      return { ...state, isContentLoading: action.data };

    case IS_CARDSLIST_LOADING:
      return { ...state, isCardslistLoading: action.data };

    case IS_LABEL_LOADING:
      return { ...state, isLabelLoading: action.data };

    case IS_USER_TAG_LOADING:
      return { ...state, isUserTagLoading: action.data };

    case IS_ISSUE_TYPE_LOADING:
      return { ...state, isIssueTypeLoading: action.data };

    case IS_FILE_FILTER_LOADING:
      return { ...state, isFileFilterLoading: action.data };

    case SET_IS_USER_CONFIG_LOADING:
      return { ...state, isUserConfigLoading: action.data };

    case SET_ISSUE_DATA:
      return { ...state, issues: action.data };

    case SET_SEVERITY_DATA:
      return { ...state, stats: action.data };

    case SET_FILTER_ISSUE:
      return { ...state, filterissue: action.data };

    case SET_DATASET_SORTING_VALUE:
      return { ...state, datasetSortingValue: action.data };

    case SET_EXPLORATION_STATS:
      return { ...state, explorationStats: action.data };

    case SET_NAVIGATION_CLUSTER:
      return { ...state, navigationCluster: action.data };

    case SET_NAVIGATION_CLUSTER_LOADER:
      return { ...state, navigationClusterLoader: action.data };

    case SET_NAVIGATION_CLUSTER_TAGS:
      return { ...state, navigationClusterTags: action.data };

    case SET_SIMILARITY_DATA:
      let similarityClusters = action.data;
      if (similarityClusters === null) {
        similarityClusters = [];
      }
      return { ...state, similarityClusters };

    case SET_SIMILARITY_VERTEX:
      return { ...state, similarityVertexCluster: action.data };

    case SET_FILTER_CONFIG:
      return {
        ...state,
        filterConfig: action.data,
      };

    case SET_TREE_FOLDER:
      return { ...state, treeFolder: action.data };

    case SET_EXPORT_DATA:
      return { ...state, exportData: action.data };

    case SET_TEMPORARY_EXPORT_DATA:
      return { ...state, temporaryExportData: action.data };

    case SET_TEMP_EXPORT_DATA:
      return { ...state, tempExportData: action.data };

    case SET_EXPORT_DATA_TIMEOUT_ID:
      return { ...state, exportDataTimeoutID: action.data };

    case SET_SHOW_CART:
      return { ...state, showCart: action.data };

    case SET_PAGINATION_METADATA_FOR_DATA:
      return { ...state, paginationMetadataForData: action.data };

    case SET_PAGINATION_METADATA_FOR_CLUSTER:
      return { ...state, paginationMetadataForCluster: action.data };

    case SET_CLUSTER_METADATA_SUMMARY:
      return { ...state, clusterMetadataSummary: action.data };

    case SET_CLUSTER_METADATA_SUMMARY_LOADING:
      return { ...state, clusterMetadataSummaryLoading: action.data };

    // filters
    case SET_SIMILARITY_THRESHOLDS:
      return {
        ...state,
        similarityThresholds: action.data.similarity_thresholds,
      };

    case SET_DATASET_LABELS:
      return { ...state, labels: action.data };

    case SET_DATASET_CONTEXTUAL_LABELS:
      return { ...state, contextualLabels: action.data };

    case SET_DATASET_ISSUE_TYPES:
      return { ...state, issueTypes: action.data };

    case SET_FILE_NAME_SEARCH_TEXT:
      return { ...state, fileNameSearchText: action.data };

    case SET_ENTITY_TYPE_FILTER:
      return { ...state, entityTypeFilter: action.data };

    case UPDATE_USER_TAGS:
      // Until we have org-tags we're hacking around by "accumalating" tags so here we concat tags and then deduplicate them by id
      const newTags = [...state.userTags, ...action.data].reduce(
        (acc, current) => {
          const x = acc.find((item: any) => item.id === current.id);
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        },
        [],
      );
      return { ...state, userTags: newTags };

    case SET_USER_TAGS:
      return { ...state, userTags: action.data };

    case SET_CONTEXTUAL_USER_TAGS:
      return { ...state, contextualUserTags: action.data };

    case SET_DATASET_TAGS:
      return { ...state, datasetTags: action.data };

    case SET_NAVIGATION_CONTEXT: {
      return { ...state, navigationContext: action.data };
    }

    case SET_IS_IMAGE_UPLOADING:
      return { ...state, isImageUploading: action.data };

    case HOVERED_FILE_STATE:
      return { ...state, hoveredFileState: action.data };

    case SET_FETCH_ERROR:
      return { ...state, fetchError: action.data };

    case SET_METADATA_SOURCES_LOADING:
      return { ...state, metadataSourcesLoading: action.data };

    case SET_DATA_METADATA_SUMMARY:
      return { ...state, dataMetadataSummary: action.data };

    case SET_DATA_METADATA_SUMMARY_LOADING:
      return { ...state, dataMetadataSummaryLoading: action.data };

    case SET_AUTOCOMPLETE_SUGGESTIONS:
      return { ...state, autocompleteSuggestions: action.data };

    case SET_RECENT_SEARCHES:
      return { ...state, recentSearches: action.data };

    case SET_AUTOCOMPLETE_LOADING:
      return { ...state, autocompleteLoading: action.data };

    case SET_AUTOCOMPLETE_NO_RESULTS_FLAG:
      return { ...state, autocompleteNoResultsFlag: action.data };

    case SET_IMAGE_PAGE_PARAMS_CONTEXT:
      return { ...state, imagePageParamsContext: action.data };

    case SET_ASSIGNED_TAGS:
      return { ...state, assignedTags: action.data };

    case SET_TEMPORARY_ASSIGNED_TAGS:
      return { ...state, temporaryAssignedTags: action.data };

    case SET_SHOW_EXPORT_MODAL:
      return { ...state, showExportModal: action.data };

    case SET_EXPORT_PROGRESS:
      return { ...state, exportProgress: action.data };

    case SET_EXPORT_STATUS:
      return { ...state, exportStatus: action.data };

    case SET_SHOW_DATASET_SHARING_MENU:
      return { ...state, showDatasetSharingMenu: action.data };

    case SET_SHOW_VIEW_SHARING_MENU:
      return { ...state, viewSharingMenu: action.data };

    case SET_USERS_WITH_ACCESS:
      return { ...state, usersWithAccess: action.data };

    case SET_INVITED_EMAILS:
      return { ...state, invitedEmails: action.data };

    case SET_LAST_SELECTED_INDEX:
      return { ...state, lastSelectedIndex: action.data };

    case SET_SCROLL_APPLIED:
      return { ...state, scrollApplied: action.data };

    case SET_DATA_PAGE_SCROLL_POSITION:
      return { ...state, dataPageScrollPosition: action.data };

    case SET_CLUSTER_PAGE_SCROLL_POSITION:
      return { ...state, clusterPageScrollPosition: action.data };

    case SET_NO_RESULTS_FOUND:
      return { ...state, noResultsFound: action.data };

    case SET_DATASET_ENRICHMENT_MODELS:
      return { ...state, enrichmentModels: action.data };

    case SET_DATASET_EXTERNAL_SOURCES:
      return { ...state, externalSources: action.data };

    case SET_CAPTIONS:
      return { ...state, captions: action.data };

    case SET_DUPLICATE_THRESHOLD_RANGE:
      return { ...state, duplicateThresholdRange: action.data };

    case SET_REMOVED_ELEMENTS_BY_UNIQUENESS_COUNT:
      return { ...state, removedElementsByUniquenessCount: action.data };

    case SET_IS_UNIQUENESS_SCORE_LOADING:
      return { ...state, uniquenessScoreLoading: action.data };

    case SET_SELECTED_QUERY_MODAL:
      return {
        ...state,
        selectedQueryModal: {
          ...action.data,
          position: action.data?.position || state.selectedQueryModal?.position,
        },
      };

    case SET_SHOW_QUERY_PANEL:
      return { ...state, showQueryPanel: action.data };

    case SET_CUSTOM_METADATA_LINK_OPTIONS:
      return { ...state, customMetadataLinkOptions: action.data };

    case SET_GLOBAL_MD_TYPE: {
      return { ...state, globalMDType: action.data as MetadataType };
    }

    default:
      return state;
  }
};

export default reducer;
